import { Packages } from '~shared/constants/pricing';
import { PackageSet } from '~shared/types/pricing/package';

export default [
  'grow_2792_survey_create_limit',
  'unlimited_questions',
  'response_count',
  'support',
  'colors',
  'exports',
  'grow_2792_skip_logic',
  'file_upload',
  'multilingual',
  'click_map_qt',
  'grow_2792_ippm_best_worst_scale',
  'grow_2792_ippm_create_piping_enabled',
  'grow_2792_ippm_a_b_testing',
  'create_toggle_footer_enabled',
];

const ALL_PACKAGES: PackageSet = [
  Packages.AdvantageAnnual,
  Packages.AdvantageMonthly,
  Packages.TeamAdvantage,
  Packages.FormsAnnual,
  Packages.FormsMonthly,
  Packages.PremierAnnual,
  Packages.TeamPremier,
];
const ADVANTAGE_PLUS: PackageSet = [
  Packages.AdvantageAnnual,
  Packages.AdvantageMonthly,
  Packages.TeamAdvantage,
  Packages.PremierAnnual,
  Packages.TeamPremier,
];
const PREMIER: PackageSet = [Packages.PremierAnnual, Packages.TeamPremier];

export const packageFeaturesIncluded = {
  grow_2792_survey_create_limit: ALL_PACKAGES,
  unlimited_questions: ALL_PACKAGES,
  response_count: ALL_PACKAGES,
  support: ALL_PACKAGES,
  colors: ALL_PACKAGES,
  exports: ALL_PACKAGES,
  grow_2792_skip_logic: ALL_PACKAGES,
  file_upload: ALL_PACKAGES,
  multilingual: ADVANTAGE_PLUS,
  click_map_qt: ADVANTAGE_PLUS,
  grow_2792_ippm_best_worst_scale: ADVANTAGE_PLUS,
  grow_2792_ippm_create_piping_enabled: PREMIER,
  grow_2792_ippm_a_b_testing: PREMIER,
  create_toggle_footer_enabled: PREMIER,
};

const YEAR = 'year';
const MONTH = 'month';
const RESPONSE_COUNT = 'grow_2792_ippm_response_count';
const EMAIL_SUPPORT = 'grow_2792_support';
const PRIORITY_EMAIL_SUPPORT = 'priority_email_support';
const PHONE_SUPPORT = 'phone_support';
const DATA_EXPORTS = 'grow_2792_analyze_export_enabled';
const ADVANCED_DATA_EXPORTS = 'grow_2792_ippm_advanced_data_exports';
const COLORS = 'grow_2792_custom_colors';
const COLORS_SURVEY_URL = 'grow_2792_custom_colors_survey_url';

export const combinedFeatureValues = {
  [Packages.FormsMonthly]: {
    response_count: {
      name: RESPONSE_COUNT,
      amount: 200,
      frequency: MONTH,
    },
    support: {
      name: EMAIL_SUPPORT,
    },
    exports: {
      name: DATA_EXPORTS,
    },
    colors: {
      name: COLORS,
    },
  },
  [Packages.FormsAnnual]: {
    response_count: {
      name: RESPONSE_COUNT,
      amount: 2500,
      frequency: YEAR,
    },
    support: {
      name: EMAIL_SUPPORT,
    },
    exports: {
      name: DATA_EXPORTS,
    },
    colors: {
      name: COLORS,
    },
  },
  [Packages.AdvantageMonthly]: {
    response_count: {
      name: RESPONSE_COUNT,
      amount: 1000,
      frequency: MONTH,
    },
    support: {
      name: PRIORITY_EMAIL_SUPPORT,
    },
    exports: {
      name: DATA_EXPORTS,
    },
    colors: {
      name: COLORS_SURVEY_URL,
    },
  },
  [Packages.AdvantageAnnual]: {
    response_count: {
      name: RESPONSE_COUNT,
      amount: 15000,
      frequency: YEAR,
    },
    support: {
      name: PRIORITY_EMAIL_SUPPORT,
    },
    exports: {
      name: DATA_EXPORTS,
    },
    colors: {
      name: COLORS_SURVEY_URL,
    },
  },
  [Packages.TeamAdvantage]: {
    response_count: {
      name: RESPONSE_COUNT,
      amount: 50000,
      frequency: YEAR,
    },
    support: {
      name: PRIORITY_EMAIL_SUPPORT,
    },
    exports: {
      name: DATA_EXPORTS,
    },
    colors: {
      name: COLORS_SURVEY_URL,
    },
  },
  [Packages.PremierAnnual]: {
    response_count: {
      name: RESPONSE_COUNT,
      amount: 40000,
      frequency: YEAR,
    },
    support: {
      name: PHONE_SUPPORT,
    },
    exports: {
      name: ADVANCED_DATA_EXPORTS,
    },
    colors: {
      name: COLORS_SURVEY_URL,
    },
  },
  [Packages.TeamPremier]: {
    response_count: {
      name: RESPONSE_COUNT,
      amount: 100000,
      frequency: YEAR,
    },
    support: {
      name: PHONE_SUPPORT,
    },
    exports: {
      name: ADVANCED_DATA_EXPORTS,
    },
    colors: {
      name: COLORS_SURVEY_URL,
    },
  },
};
